<!--
 * @Author: 仙道
 * @Date: 2022-06-18 16:44:24
 * @LastEditTime: 2022-09-18 11:04:11
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/components/jeecgbiz/JSelectDeviceClass.vue
-->
<template>
  <j-select-biz-component :width="1200" returnId v-bind="configs" v-on="$listeners" />
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectDeviceClass',
    components: { JSelectBizComponent },
    props: ['value'],
    data () {
      return {
        settings: {
          name: '设备类型',
          displayKey: 'typeName',
          valueKey: 'id',
          returnKeys: ['id', 'typeName'],
          listUrl: '/device/devClass/list',
          queryParamCode: 'typeName',
          queryParamText: '设备类型名称',
          ellipsisLength: -1,
          columns: [
            {
              title: '分类名称',
              align: 'center',
              dataIndex: 'typeName'
            },
            { title: '分类编码', dataIndex: 'typeCode', align: 'center', width: '30%', widthRight: '70%' },
          ]
        }
      }
    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    }
  }
</script>

<style lang="less" scoped></style>
